import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TApplication, adaptApplicationFromResponse } from 'src/store';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_APPLICATION } from '../../backend-paths';


export const applicationDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_ADMIN_APPLICATION}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ADMIN_APPLICATION}/${payload}`;

		return HttpService.delete(path).then(result => {
			return adaptApplicationFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TApplication> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const applicationDeleteSlice = createSlice({
	name: 'applicationDeleteSlice',
	initialState,
	reducers: {
		clearApplicationDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[applicationDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[applicationDeleteApi.fulfilled.type]: (state, action: PayloadAction<TApplication>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[applicationDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useApplicationDeleteSelector = () => useAppSelector(state => state[applicationDeleteSlice.name]);

export const { clearApplicationDelete } = applicationDeleteSlice.actions;
